export default function initSocialFeedBlock() {
    [].slice.apply(document.querySelectorAll('.fsocial')).forEach(initBlock);
}

/**
 * @param {HTMLElement} root
 */
function initBlock(root) {
    const wrapperEl = root.querySelector('.fsocial-sbWall');

    if (!wrapperEl) {
        return;
    }

    const itemEls = [].slice.apply(wrapperEl.querySelectorAll('.sbsw-item'));

    if (itemEls.length < 2) {
        return;
    }

    const headEl = itemEls.shift();
    const btnEl = Object.assign(document.createElement('button'), {
        innerText: `Visa fler`,
        className: `fsocial-readMore`,
        title: `Visa mer sociala inlägg`,
    });

    btnEl.addEventListener('click', () => maximize({ byUser: true }));
    wrapperEl.appendChild(btnEl);

    recalc();
    window.addEventListener('resize', recalc);
    window.addEventListener('orientationchange', recalc);

    function isMinimized() {
        return wrapperEl.classList.contains('is--minimized');
    }

    function recalc() {
        if (window.innerWidth < LBRL_HEADERS.mbhThreshold && !isMinimized()) {
            minimize();
        } else if (window.innerWidth >= LBRL_HEADERS.mbhThreshold && isMinimized()) {
            maximize();
        }
    }

    function minimize() {
        wrapperEl.classList.add('is--minimized');
        wrapperEl.style.height = headEl.offsetHeight + btnEl.offsetHeight + 'px';
    }

    function maximize(args) {
        wrapperEl.classList.remove('is--minimized');
        wrapperEl.style.height = '';
        if (args && args.byUser) {
            window.removeEventListener('resize', recalc);
            window.removeEventListener('orientationchange', recalc);
        }
    }
}
